<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style>
body{margin:0;}
body *{box-sizing: border-box;}
#app {
  font-family: Arial, sans-serif, 'MicrosoftYaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:#333;
}
.bold{font-weight: bold;}
.text-center{text-align: center;}
.text-left{text-align: left;}
.text-right{text-align: right;}
a{color:#333;text-decoration: none;}
ul,li{margin:0;padding:0;list-style: none;}
.d-flex{display: flex;}
.d-shrink{flex-shrink: 0;}
.d-grow{flex-basis: 100%;flex-grow: 1;min-width: 0;}
.ellipsis{text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
.pointer{cursor: pointer;}
.overflow{overflow: hidden;}
.table{display: table;width:100%;height:100%}
.line2{display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.layout{background: #f6f8fb;}
.layout-container{width:1200px;margin:0 auto}
.layout-container .block{background: #fff;border:solid 1px #e5e5e5;border-radius: 4px;}
.el-footer{height:auto!important;margin-top:30px}
.position{line-height: 60px;}
.position a{color:#999}
.position b{margin:0 5px;position: relative;top:-1px;color:#999;font-weight: normal;}
.position span{color:#666}
.indent{text-indent: 2em;}
.el-button--primary,.el-button--primary:focus, .el-button--primary:hover{
    background: #e61a1e;
    border-color: #e61a1e;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover{
    background: #999;
    border-color: #999;
}
.el-message-box__wrapper .el-button--primary, .el-dialog__wrapper .el-button--primary{
    background: #e61a1e;
    border-color: #e61a1e;
}
.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close{
    color: #e61a1e
}
.el-textarea__inner{
    font-family: Arial, sans-serif, 'MicrosoftYaHei';
}
.el-button--text,.el-button--text:hover,.el-button--text:focus,.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path,.el-date-table td.today span,.el-date-table td.available:hover{
    color: #e61a1e
}
.el-date-table td.end-date span, .el-date-table td.start-date span{
    background-color: #e61a1e;
}
.el-input--small .el-input__inner{
    height:35px;
    line-height: 35px;
    vertical-align: middle;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus,.el-select .el-input__inner:focus,.el-select .el-input.is-focus .el-input__inner{
    border-color:#e61a1e
}
.el-footer{padding:0}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#e61a1e;
    border-color:#e61a1e;
}
.el-checkbox__inner:hover,.el-radio__inner:hover{border-color:#e61a1e}
.el-radio__input.is-checked .el-radio__inner{
    background:#e61a1e;
    border-color:#e61a1e;
}
.el-upload-list__item-name,.el-radio__input.is-checked+.el-radio__label,.el-checkbox__input.is-checked+.el-checkbox__label{
    color:#e61a1e
}
.el-date-table td.current:not(.disabled) span{background-color:#e61a1e ;}
.sh5show{display: none;}
@media screen and (max-width: 1200px) {
    .layout-container{width:100%;margin:0 auto;padding:0 15px}

}
@media screen and (max-width: 440px) {
  .h5hide{display: none;}
  .sh5show{display: block;}
  .el-pager .number:not(.active){display: none;}
  .el-input.is-disabled .el-input__inner{color:#aaa}
}

/* 修复 在ios设备中，el-select组件下拉框，点击2次才能选中问题。 */
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue